import { render, staticRenderFns } from "./D3-pie.vue?vue&type=template&id=01190d29&scoped=true"
import script from "./D3-pie.vue?vue&type=script&lang=js"
export * from "./D3-pie.vue?vue&type=script&lang=js"
import style0 from "./D3-pie.vue?vue&type=style&index=0&id=01190d29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01190d29",
  null
  
)

export default component.exports